import { render } from "./BaseOrangeButton.vue?vue&type=template&id=29ad1d1a"
import script from "./BaseOrangeButton.vue?vue&type=script&lang=js"
export * from "./BaseOrangeButton.vue?vue&type=script&lang=js"

import exportComponent from "/Users/maksimzugan/code/nacd-3-family/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__